import * as React from 'react';
import { Grid } from '@mui/material';
import SelectDataPool from './SelectDataPool';
import { AppContext } from '../../App';
import { useNavigate } from 'react-router';

function SelectDefaults() {
  const { dataPoolId, dataPoolTotal } = React.useContext(AppContext);
  const navigate = useNavigate();

  if (dataPoolId && dataPoolTotal === 1) {
    navigate('/');
  }

  // staff actually will go to OrgPage instead.
  // TODO: non staff assigned to more than one org, needs to select to filter org
  return (
    <div id="select-defaults">
      <Grid container spacing={8}>
        <Grid item xs={12} style={{ margin: '2em' }}>
          <SelectDataPool />
        </Grid>
      </Grid>
    </div>
  );
}

export default SelectDefaults;
